import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;
`;

export const HeaderDetails = styled.header`
	align-items: center;
	display: grid;
	gap: 12px;
	grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
	width: 100%;
`;

export const TableContainer = styled.div`
	display: flex;
	flex-direction: column;
`;
